<template>

  <!-- 声音模块 -->
  <div class="audio" id="BGMUSIC-SWF">

    <div class="mask" v-show="mask_visible"></div>

    <!-- 切换标签组件 tabs-category -->
    <div class="category-nav">
      <div v-for="item, index in nav"
           :class="{'active':item.active}"
           @click="handleNavChange(index, nav)">{{item.name}}</div>
    </div>

    <!-- 搜索组件 search -->
    <div class="search">
      <div class="search-inner">
        <input type="text" class="text" placeholder="请输入背景音" v-model="search_key">
        <span class="icon-search button" @click="handleSearch()"></span>
        <span class="el-icon-close button" @click="handleSearchClose" v-show="search_key.length > 0"></span>
      </div>
    </div>

    <!-- 播放组件 -->
    <div class="player" v-show="music_play_status">
      <div class="box-music">
        <div class="title">已选: &nbsp {{bgm_title}}<i @click="handleBgmCancle" class="el-icon-close"></i></div>
        <div class="control">
          <div class="play_pause">
            <i @click="handleBgmPlay" class="icon-play" v-show="play_status"></i>
            <i @click="handleBgmPause" class="icon-pause" v-show="!play_status"></i>
            <i class="icon-mute" style="font-size:24px; color:#4a4a4a;" v-show="volume == 0"></i>
            <i class="icon-voice" style="font-size:24px; color:#4a4a4a;" v-show="volume > 0"></i>
          </div>
          <div class="volume_change">
            <el-slider style="-webkit-transform:scale(0.55);width:270px;left:-60px;position:relative;" v-model="volume" @change="handleVolumeChange" :step='1'></el-slider>
          </div>
          <div class="volume_show">{{volume}}</div>
        </div>
      </div>
      <audio id="audio-bgm" :src="audio_player" loop></audio>
    </div>

    <!-- 没有内容默认显示 -->
    <div class="no_results" v-show="no_result">
      <div class="pic">
        <img src="./no_result.png">
      </div>
    </div>

    <!-- 公共市场 -->
    <div class="content" :class="{position_top: music_play_status}" v-if="nav_status == 0">

      <!-- 背景音分类组件 category -->
      <div class="category-type" v-show="!search_status">
        <div
          v-for="item, index in category_bgm_public"
          @click="handleCategoryPublicChange(item, index)"
          :class="{'active':item.active}" >
          {{item.name}}
        </div>
      </div>

      <!-- 素材列表组件 list -->
      <div class="list" :class="hideLeft">
        <div class="con">
          <div class="item" v-for="item, index in public_bgm_list" @mousedown="handlePublicItemDown(item, $event)"  @mouseup="handlePublicItemUp(item, $event)">
            <div class="inner">
              <div class="pic"><img src="./music.png"></div>
              <div class="text">
                <div class="name"><span>{{item.title}}</span><span class="tips">免费</span></div>
                <div class="desc" :title="item.copyright">{{item.copyright}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="more" @click="handleMore" v-show="more">
          <div class="inner">加载更多</div>
        </div>
      </div>
    </div>

    <!-- 我的 -->
    <div class="content" :class="{position_top: music_play_status}" v-if="nav_status == 1">

      <!-- 素材列表组件 list -->
      <div class="list" style="left: 0;">
        <!-- 面包屑组件 -->
        <div class="breadcrumb">
          <span
            v-if="breadcrumb.length > 1"
            v-for="item, index in breadcrumb"
            @click="handleTargetNav(index, item.folder_id)">
            {{item.name == '根文件夹' ? item.name : '/ ' + item.name}}
          </span>
        </div>
        <!-- 列表数据 -->
        <div class="con">
          <div class="item" v-for="item in self_bgm_list" @click="handleItemFolderSelf(item)">
            <div class="inner">
              <div class="pic">
                <img src="./folder.png" v-if="item.type == 'folder'">
                <img src="./music.png" v-if="item.type != 'folder'">
              </div>
              <div class="text">
                <div class="name"><span>{{item.title}}</span><span class="tips" v-if="item.type != 'folder'">免费</span></div>
                <div class="desc" :title="item.copyright">{{item.copyright}}</div>
              </div>
            </div>
          </div>

        </div>

        <div class="more" @click="handleMore" v-show="more">
          <div class="inner">加载更多</div>
        </div>
      </div>

    </div>

    <!-- 团队 -->
    <div class="content" :class="{position_top: music_play_status}" v-if="nav_status == 2">

     <!-- 素材列表组件 list -->
      <div class="list" style="left: 0;">
        <!-- 面包屑组件 -->
        <div class="breadcrumb">
          <span
            v-if="breadcrumb.length > 1"
            v-for="item, index in breadcrumb"
            @click="handleTargetNav(index, item.folderId)">
            {{item.name == '根文件夹' ? item.name : '/ ' + item.name}}
          </span>
        </div>
        <!-- 列表数据 -->
        <div class="con">
          <div class="item" v-for="item in team_bgm_list" @click="handleItemFolderSelf(item)">
            <div class="inner">
              <div class="pic">
                <img src="./folder.png" v-if="item.type == 'folder'">
                <img src="./music.png" v-if="item.type != 'folder'">
              </div>
              <div class="text">
                <div class="name"><span>{{item.title}}</span><span class="tips" v-if="item.type != 'folder'">免费</span></div>
                <div class="desc" :title="item.copyright">{{item.copyright}}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="more" @click="handleMore" v-show="more">
          <div class="inner">加载更多</div>
        </div>
      </div>
    </div>

    <!-- Psocket 组件 -->
    <psocket :attributes="attributes" :flashvars="flashvars" v-if="platform == 'qt'"></psocket>

  </div>

</template>

<script>
// Psocket 组件
import Psocket from "@/components/Flash/PSocket";

// 通讯协议
import Protocol from "@/common/scripts/protocol.js";

import { eventBus } from "@/common/scripts/eventBus.js";

export default {
  // 组件
  components: {
    Psocket
  },
  // 计算
  computed: {},
  data() {
    return {
      platform: this.$route.query.platform,
      init: "",

      // nav数据
      nav: [
        {
          name: "公共市场",
          active: true
        },
        {
          name: "我的",
          active: false
        }
      ],

      // nav 状态
      nav_status: "",

      // category 数据
      category_bgm_public: [
        {
          name: "收藏"
        }
      ],

      // category状态
      category_status: "",

      // 搜索关键字
      search_key: "",

      // 分页数据
      page_size: 20,
      current_page: 1,

      // 更多按钮状态
      more: true,

      // 公共市场-->分类id
      category_id: "",

      // 列表数据
      public_bgm_list: [],
      self_bgm_list: [],
      team_bgm_list: [],

      // 我的--团队--文件夹
      breadcrumb: [{ name: "根文件夹", folder_id: "/" }],

      // 音乐播放地址
      audio_player: "",

      // 音乐播放器声音
      volume: 0,

      // 音乐播放器音乐ID
      bgmId:"",

      // 播放按钮
      audio_tips: "暂停",

      // 音乐标题
      bgm_title: "",

      // 音乐播放状态
      play_status: false,

      // 团队ID
      team_id: "",

      // 列表无内容默认显示
      no_result: false,

      dialog_collect_visible: false,

      dialog_cancel_collect_visible: false,

      collect_time: null,

      ops_id: "",

      folder_id: "",

      music_play_status: false,

      // 遮罩层
      mask_visible: true,

      //声音编辑模式 video/audio
      mTimelineEditMode: "video",

      // -------------------------------------------------- [ FLASH ] --------------------------------------------------

      flashvars: {
        module: BGMUSIC_NAME
      },

      attributes: {
        id: BGMUSIC_NAME + "-PSOCKET"
      },

      has_token: "",

      has_user_id: "",

      search_status: false,

      voice: ""
    };
  },
  methods: {
    // -------------------------------------------------------------[ 页签切换 ]-----------------------------------

    // nav切换-----公共市场/我的/团队
    handleNavChange(index, data) {
      if (this.nav_status != index) {
        //赋值nav状态
        this.nav_status = index;

        // nav样式变化
        this.changeTab(index, data);

        this.handleSearchClose();
      }
    },

    // Category切换----公共市场----所有/最近/收藏/分类
    handleCategoryPublicChange(item, index) {
      // 防止重复点击
      if (this.category_status != index) {
        // category状态赋值
        this.category_status = index;

        // 分类id赋值
        this.category_id = item.id;

        // 样式更改
        this.changeTab(index, this.category_bgm_public);

        // 目录清空
        (this.breadcrumb = [{ name: "根文件夹", folder_id: "/" }]),
          (this.folder_id = "");

        // 数据重置
        this.current_page = 1;
        this.public_bgm_list = [];

        // API 加载数据
        this.handleGetDataTotal(
          this.page_size,
          this.current_page,
          this.search_key,
          this.category_id,
          this.folder_id,
          this.team_id
        );
      }
    },

    // 切换公共方法
    changeTab(index, data) {
      for (let i = 0; i < data.length; i++) {
        data[i].active = false;
      }

      data[index].active = true;
    },

    // ---------------------------------------------------------------【 搜索操作 】-------------------------------

    // 开始搜索
    handleSearch() {
      this.search_status = true;

      // 公共市场--我的--团队 数据清空
      this.public_bgm_list = [];
      this.self_bgm_list = [];
      this.team_bgm_list = [];

      this.current_page = 1;

      this.handleGetDataTotal(
        this.page_size,
        this.current_page,
        this.search_key,
        this.category_id,
        this.folder_id,
        this.team_id
      );
    },

    // 搜索重置
    handleSearchClose() {
      this.search_key = "";

      this.handleSearch();

      this.search_status = false;
    },

    // --------------------------------------------------------------【 加载更多 】----------------------------------

    // 加载更多
    handleMore() {
      this.current_page++;

      this.handleGetDataTotal(
        this.page_size,
        this.current_page,
        this.search_key,
        this.category_id,
        this.folder_id,
        this.team_id
      );
    },

    // ------------------------------------------------【 背景音播放相关 】------------------------------------

    // 点击我的文件夹
    handleItemFolderSelf(item) {
      if (item.type == "folder") {
        let name = item.title;

        this.folder_id = item.id;

        this.breadcrumb.push({
          name: name,
          folder_id: this.folder_id
        });

        this.handleSearchClose();
      } else {
        this.music_play_status = true;

        this.handleItemPlayBgm(item);
      }
    },

    // 目录跳转
    handleTargetNav(index, folder_id) {
      this.current_page = 1;

      let arr = [];

      for (let i = 0; i < this.breadcrumb.length; i++) {
        if (i <= index) {
          arr.push(this.breadcrumb[i]);
        }
      }

      this.breadcrumb = arr;

      if (folder_id == "/") {
        this.folder_id = "";

        this.handleGetDataTotal(
          this.page_size,
          this.current_page,
          this.search_key,
          this.category_id,
          this.folder_id,
          this.team_id
        );
      } else {
        this.folder_id = folder_id;

        this.handleGetDataTotal(
          this.page_size,
          this.current_page,
          this.search_key,
          this.category_id,
          this.folder_id,
          this.team_id
        );
      }
    },

    // 列表点击----单个播放
    handleItem(item) {
      this.handleItemPlayBgm(item);
    },

    // 鼠标按下
    handlePublicItemDown(item, ev) {
      if (ev.button == 2) {
        // alert('right')
        document.oncontextmenu = function() {
          return false;
        };
      }
      this.collect_time = setTimeout(() => {
        this.ops_id = item.id;

        if (this.category_status == "2") {
          this.ops_id = item.matter_id;
        } else {
          this.ops_id = item.id;
        }
        if ("public" == this.tab_tab_init) {
          if (item.isFav) {
            this.dialog_cancel_collect_visible = true;
            eventBus.$emit("dialogOpen", {
              dialog_cancel_collect_visible: true,
              component_name: "bgm"
            });
          } else {
            this.dialog_collect_visible = true;
            eventBus.$emit("dialogOpen", {
              dialog_collect_visible: true,
              component_name: "bgm"
            });
          }
        }
      }, 500);
    },

    handlePublicItemUp(item, ev) {
      if (ev.button == 2) {
        // alert('right')
        document.oncontextmenu = function() {
          return false;
        };
      } else {
        clearInterval(this.collect_time);

        this.handleItemPlayBgm(item);

        this.music_play_status = true;

        if (this.category_status == "2") {
          // 记录点击
          this.handleLastList(item.matter_id);
        } else {
          // 记录点击
          this.handleLastList(item.id);
        }
      }
    },

    // 确认收藏
    handleCollect() {
      this.dialog_collect_visible = false;

      this.handlePostCollectMatter(this.ops_id, "bgm");
    },

    // 确认取消收藏
    handleCancelCollect() {
      this.dialog_cancel_collect_visible = false;

      this.handlePostCancelCollectMatter(this.ops_id, "bgm");
    },

    // 声音修改
    handleVolumeChange(val) {
      // console.log('handleVolumeChange===========>')
      if (this.voice == this.volume) {
        return false;
      }

      let audio = document.getElementById("audio-bgm");

      audio.volume = parseFloat(val / 100);

      this.handleSendMsgChangeVolume(parseFloat(val / 100));
    },

    // 点击播放按钮
    handleBgmPlay() {
      let audio = document.getElementById("audio-bgm");

      // 检查音频源是否有效
      if (!audio.src || audio.src === "" || audio.src === window.location.href) {
        console.warn("音频源未设置或无效");
        this.$message.warning("请先选择背景音乐");
        return;
      }

      this.play_status = false;

      // 使用 Promise 处理播放，捕获错误
      audio.play().catch(error => {
        console.error("播放失败:", error);
        this.$message.error("播放失败，请检查音频文件");
        this.play_status = true;
      });
    },

    // 点击暂停按钮
    handleBgmPause() {
      let audio = document.getElementById("audio-bgm");

      this.play_status = true;
      audio.pause();
    },

    // 点击取消按钮
    handleBgmCancle() {
      this.music_play_status = false;

      let audio = document.getElementById("audio-bgm");

      audio.src = "";

      this.bgm_title = "";

      //发送消息取消背景音

      let ori_data_id = "";
      this.handleSendMsgChangeBgm(ori_data_id);
    },

    // --------------------------------------------------------[ api ]----------------------------------------------

    // 获取数据总处理
    handleGetDataTotal(
      page_size,
      current_page,
      search_key,
      category_id,
      folder_id,
      team_id
    ) {
      // 公共市场
      if (this.nav_status == 0) {
        if (this.category_status == 2) {
          // 收藏
          this.handleGetPublicBgmFavoriteListDate(
            page_size,
            current_page,
            search_key
          );
        } else {
          // 其他
          this.handleGetPublicBgmListDate(
            page_size,
            current_page,
            category_id,
            search_key
          );
        }
      }

      // 我的
      if (this.nav_status == 1) {
        this.handleGetBgmSelfListDate(
          page_size,
          current_page,
          folder_id,
          search_key
        );
      }

      // 团队
      if (this.nav_status == 2) {
        this.handleGetBgmTeamListDate(
          folder_id,
          page_size,
          current_page,
          search_key,
          team_id
        );
      }
    },

    // 背景音列表-->公共市场
    handleGetPublicBgmListDate(
      page_size,
      current_page,
      category_id,
      search_key
    ) {
      let URL = process.env.HOST + "/api/storage/market/matters";

      let headers = {
        Authorization: this.has_token
      };

      let params = {
        type: "bgm",
        page: current_page,
        pageSize: page_size,
        categoryId: category_id,
        keyword: search_key
      };

      this.AJAX
        .get(URL, headers, params)
        .then(data => {
          if (data.code == 10000) {
            // 第一页数据为空
            if (current_page == 1 && data.datas.rows.length == 0) {
              this.no_result = true;
              this.more = false;
            } else {
              // 正常数据处理
              this.no_result = false;

              // 第一页数据特殊处理
              if (current_page == 1) {
                this.public_bgm_list = data.datas.rows;
              } else {
                // 加载更多正常处理
                this.public_bgm_list = this.public_bgm_list.concat(
                  data.datas.rows
                );
              }

              if (data.datas.rows.length >= this.page_size) {
                this.more = true;
                return false;
              } else {
                this.more = false;
                return false;
              }
            }
          }
        })
        .catch(err => {
          this.$message({
            message: err.msg||err.message,
            type: "error"
          });
        });
    },
    // 背景音乐-->公共市场-->收藏
    handleGetPublicBgmFavoriteListDate(page_size, current_page, search_key) {
      let URL = process.env.HOST + "/api/storage/market/matters/favorites";

      let headers = {
        Authorization: this.has_token
      };

      let params = {
        type: "bgm",
        page: current_page,
        pageSize: page_size,
        keyword: search_key
      };

      this.AJAX
        .get(URL, headers, params)
        .then(data => {
          if (data.code == 10000) {
            // 第一页数据为空
            if (current_page == 1 && data.datas.rows.length == 0) {
              this.no_result = true;
              this.more = false;
            } else {
              // 正常数据处理
              this.no_result = false;

              // 第一页数据特殊处理
              if (current_page == 1) {
                this.public_bgm_list = data.datas.rows;
              } else {
                // 加载更多正常处理
                this.public_bgm_list = this.public_list_data.concat(
                  data.datas.rows
                );
              }

              if (data.datas.rows.length >= this.page_size) {
                this.more = true;
                return false;
              } else {
                this.more = false;
                return false;
              }
            }
          }
        })
        .catch(err => {
          this.$message({
            message: err.msg||err.message,
            type: "error"
          });
        });
    },

    // 背景音列表-->我的
    handleGetBgmSelfListDate(page_size, current_page, folder_id, search_key) {
      let URL = process.env.HOST + "/api/storage/storage/resource/v1/list";

      let headers = {
        Authorization: this.has_token
      };

      let params = {
        type: "bgm",
        page: current_page,
        pageSize: page_size,
        folderId: folder_id,
        keyword: search_key
      };

      this.AJAX
        .get(URL, headers, params)
        .then(data => {
          if (data.code == 10000) {
            // 第一页数据为空
            if (current_page == 1 && data.datas.rows.length == 0) {
              this.no_result = true;
              this.more = false;
            } else {
              // 正常数据处理
              this.no_result = false;

              // 第一页数据特殊处理
              if (current_page == 1) {
                this.self_bgm_list = data.datas.rows;
              } else {
                // 加载更多正常处理
                this.self_bgm_list = this.self_bgm_list.concat(data.datas.rows);
              }

              if (data.datas.rows.length >= this.page_size) {
                this.more = true;
                return false;
              } else {
                this.more = false;
                return false;
              }
            }
          }
        })
        .catch(err => {
          this.$message({
            message: err.msg||err.message,
            type: "error"
          });
        });
    },

    // 背景音列表-->团队
    handleGetBgmTeamListDate(
      folder_id,
      page_size,
      current_page,
      search_key,
      team_id
    ) {
      let URL = process.env.HOST + "/api/storage/storage/resource/v1/list";

      let headers = {
        Authorization: this.has_token
      };

      let params = {
        type: "bgm",
        page: current_page,
        pageSize: page_size,
        folderId: folder_id,
        keyword: search_key,
        teamId: team_id
      };

      this.AJAX
        .get(URL, headers, params)
        .then(data => {
          // 第一页数据为空
          if (current_page == 1 && data.datas.rows.length == 0) {
            this.no_result = true;
            this.more = false;
          } else {
            // 正常数据处理
            this.no_result = false;

            // 第一页数据特殊处理
            if (current_page == 1) {
              this.team_bgm_list = data.datas.rows;
            } else {
              // 加载更多正常处理
              this.team_bgm_list = this.team_bgm_list.concat(data.datas.rows);
            }

            if (data.datas.rows.length >= this.page_size) {
              this.more = true;
              return false;
            } else {
              this.more = false;
              return false;
            }
          }
        })
        .catch(err => {
          this.$message({
            message: err.msg||err.message,
            type: "error"
          });
        });
    },

    // 素材分类
    handleGetCategory() {
      let URL = process.env.HOST + "/api/storage/market/categories";

      let headers = {
        Authorization: this.has_token
      };

      let params = {
        type: "bgm"
      };

      this.AJAX
        .get(URL, headers, params)
        .then(data => {
          if (data.code == 10000) {
            // 初始左侧导航赋值
            this.category_bgm_public = [
              {
                name: "所有",
                active: true,
                id: ""
              },
              {
                name: "收藏",
                active: false,
                id: "collect"
              }
            ];

            for (var i = 0; i < data.datas.rows.length; i++) {
              data.datas.rows[i].active = false;
            }

            this.category_bgm_public = this.category_bgm_public.concat(
              data.datas.rows
            );
          }
        })
        .catch(err => {
          debugger
          this.$message({
            message: err.msg||err.message,
            type: "error"
          });
        });
    },

    // 同步背景音数据
    handleSyncBgmDetail(_this, id) {
      let param = this.ListByIdCache.check([id])
      // console.log('bgm =====> listById ' + JSON.stringify(id) + JSON.stringify(param))
      if(Object.keys(param.cache).length > 0){
        _this.audio_player = param.cache[id].src_url;
        _this.bgm_title = param.cache[id].title;
        let audio = document.getElementById("audio-bgm");
        audio.src = param.cache[id].src_url;
        _this.play_status = true;
      }

      if(param.newId.length) {
          let URL = process.env.HOST + '/pro/api/matter/listByIds'
          let params = 'id=' + param.newId.toString()
          let headers = {
              'token': this.has_token,
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
          }
          this.AJAX.post(URL, headers, params).then((data)=>{
              if(data.code == '0' && Object.keys(data.result).length > 0){
                  _this.audio_player = data.result[id].src_url;
                  _this.bgm_title = data.result[id].title;
                  let audio = document.getElementById("audio-bgm");
                  audio.src = data.result[id].src_url;
                  _this.play_status = true;
                  // 将新的id data添加到缓存中
                  this.ListByIdCache.cacheIdData(data.result)
              }

          }).catch((err)=>{
              this.$message({
                  message: err.msg||err.message,
                  type: 'error'
              })
          })
      }

      // let URL = process.env.HOST + "/pro/api/matter/listByIds";
      // let params = "id=" + id.toString();
      // let headers = {
      //   token: _this.has_token,
      //   "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
      // };

      // _this.AJAX.post(URL, headers, params).then(data => {
      //     _this.audio_player = data.result[id].src_url;
      //     _this.bgm_title = data.result[id].title;
      //     let audio = document.getElementById("audio-bgm");
      //     audio.src = data.result[id].src_url;
      //     _this.play_status = true;
      //     // audio.play()
      //   }).catch(err => {
      //     this.$message({
      //       message: err.msg||err.message,
      //       type: "error"
      //     });
      //   });
    },

    // 列表点击单个进行播放
    handleItemPlayBgm(item) {
      if(this.mTimelineEditMode == "video") {
        //添加背景音 显示在播放器中并播放
        // 初始化音乐标签
        let audio = document.getElementById("audio-bgm");

        // 检查音频源是否有效
        if (!item.src_url || item.src_url === "") {
          console.warn("音频源无效:", item);
          this.$message.warning("音频文件地址无效");
          return;
        }

        // 获取音乐相关数据
        this.audio_player = item.src_url;
        this.bgm_title = item.title;

        audio.src = item.src_url;

        if (this.volume == 0) {
          this.volume = 100;
        }

        audio.volume = parseFloat(this.volume / 100);

        this.handleSendMsgChangeVolume(parseFloat(this.volume / 100));

        // 等待音频加载后播放
        audio.addEventListener('canplay', () => {
          audio.play().catch(error => {
            console.error("播放失败:", error);
            this.$message.error("播放失败，请检查音频文件");
            this.play_status = true;
          });
          this.play_status = false;
        }, { once: true });

        // 添加加载错误处理
        audio.addEventListener('error', (e) => {
          console.error("音频加载失败:", e);
          this.$message.error("音频加载失败，请检查文件地址");
          this.play_status = true;
        }, { once: true });

        // 设置超时，避免长时间等待
        setTimeout(() => {
          if (audio.readyState < 3) {
            console.warn("音频加载超时");
          }
        }, 5000);
      } else {
        //添加音轨 不显示在播放器中
      }
      //发送消息
      if (this.nav_status == 0) {
        // 发送消息
        this.handleSendMsgChangeBgm(item.oriDataId);
      } else {
        // 发送消息
        this.handleSendMsgChangeBgm(item.id);
      }

    },
    // 发送消息--更换背景音
    handleSendMsgChangeBgm(ori_data_id) {
      let platform = this.$route.query.platform;

      let MMaterial = new proto.com.proto.material.MMaterial();

      let MMaterialType = "bgm";

      MMaterial.setType(MMaterialType);
      MMaterial.setId(ori_data_id);

      // protobuf 序列化
      let protoBytes = MMaterial.serializeBinary();

      // Uint8Array 转换 Array
      let protoBytesArray = Array.from(protoBytes);

      let bgm_scene_3_1 = {
        packageId: 0,
        senderId: BGMUSIC,
        senderName: BGMUSIC_NAME,
        receiverId: SCENE,
        receiverName: SCENE_NAME,
        timeFlag: new Date().getTime(),
        sessionId: 3,
        messageId: 1,
        protoBytesType: "proto.com.proto.material.MMaterial",
        protoBytes: protoBytesArray
      };

      // 发送消息
      Protocol.sender(platform, bgm_scene_3_1);
    },

    // 发送消息---音量变化
    handleSendMsgChangeVolume(val) {
      let platform = this.$route.query.platform;

      let MFloat = new proto.com.proto.s.MFloat();

      let value = parseFloat(val);

      MFloat.setValue(value);

      // protobuf 序列化
      let protoBytes = MFloat.serializeBinary();

      // Uint8Array 转换 Array
      let protoBytesArray = Array.from(protoBytes);

      let bgm_scene_6_17 = {
        packageId: 0,
        senderId: BGMUSIC,
        senderName: BGMUSIC_NAME,
        receiverId: SCENE,
        receiverName: SCENE_NAME,
        timeFlag: new Date().getTime(),
        sessionId: 6,
        messageId: 17,
        protoBytesType: "proto.com.proto.s.MFloat",
        protoBytes: protoBytesArray
      };

      // 发送消息
      Protocol.sender(platform, bgm_scene_6_17);
    },

    // api--post--收藏素材
    handlePostCollectMatter(id, type) {
      let URL = process.env.HOST + "/api/storage/market/matters/favorites";

      let params = {
        type: type,
        matterId: id
      };

      let headers = {
        Authorization: this.has_token
      };

      this.AJAX
        .post(URL, headers, params)
        .then(data => {
          this.$message({
            message: "收藏成功",
            type: "success"
          });

          this.current_page = 1;
          this.handleGetDataTotal(
            this.page_size,
            this.current_page,
            this.search_key,
            this.category_id,
            this.folder_id,
            this.team_id
          );
        })
        .catch(err => {
          this.$message({
            message: err.msg||err.message,
            type: "error"
          });
        });
    },

    // api--post--取消收藏
    handlePostCancelCollectMatter(id, type) {
      let URL = process.env.HOST + "/api/storage/market/matters/favorites/delete";

      let params = {
        matterId: id,
        type: type
      };

      let headers = {
        Authorization: this.has_token,
      };

      this.AJAX
        .post(URL, headers, params)
        .then(data => {
          this.$message({
            message: "取消成功",
            type: "success"
          });

          this.current_page = 1;
          this.handleGetDataTotal(
            this.page_size,
            this.current_page,
            this.search_key,
            this.category_id,
            this.folder_id,
            this.team_id
          );
        })
        .catch(err => {
          this.$message({
            message: err.msg||err.message,
            type: "error"
          });
        });
    }
  },
  created() {
    eventBus.$on("handleCollect_bgm", target => {
      this.handleCollect();
    });
    eventBus.$on("handleCancelCollect_bgm", target => {
      this.handleCancelCollect();
    });
  },
  computed: {
    // 搜索隐藏左侧daohang
    hideLeft() {
      if (this.search_status) {
        return "position-left0";
      }
    }
  },

  watch: {
    search_key: function() {
      // this.search_key = this.search_key.replace(/(^\s*)|(\s*$)/g, "");
      if (this.search_key == "") {
        if (this.search_status) {
          this.handleSearchClose();
        }
      }
    }
  },
  mounted() {
    let platform = this.$route.query.platform;

    let _this = this;

    // ACTION
    // 模块初始化
    Protocol.onSocketInit(platform, BGMUSIC_NAME, BGMUSIC);
    // 模块与服务器建立链接
    Protocol.onSocketConnect(platform, BGMUSIC_NAME);
    // 模块与服务器建立链接
    Protocol.onSocketRegister(platform, BGMUSIC_NAME, BGMUSIC);

    // 接收消息
    Protocol.receiver(platform, BGMUSIC_NAME);

    window[BGMUSIC_NAME].domReady = () => {
      // 向用户系统请求用户数据
      let bgm_core_1_3 = {
        packageId: 0,
        senderId: BGMUSIC,
        senderName: BGMUSIC_NAME,
        receiverId: CORE,
        receiverName: CORE_NAME,
        timeFlag: new Date().getTime(),
        sessionId: 1,
        messageId: 3,
        protoBytesType: "",
        protoBytes: []
      };
      // 发送消息
      Protocol.sender(platform, bgm_core_1_3);

      // console.log('bgm---向用户系统请求用户数据')

      //请求Token
      let material_bgm_1_1 = {
        packageId: 0,
        senderId: BGMUSIC,
        senderName: BGMUSIC_NAME,
        receiverId: CORE,
        receiverName: CORE_NAME,
        timeFlag: new Date().getTime(),
        sessionId: 1,
        messageId: 1,
        protoBytesType: "proto.com.proto.s.MToken",
        protoBytes: []
      };
      // 发送消息
      Protocol.sender(platform, material_bgm_1_1);

      // console.log('bgm---请求Token')

      // 请求当前tab数据
      let bgm_core_1_11 = {
        packageId: 0,
        senderId: BGMUSIC,
        senderName: BGMUSIC_NAME,
        receiverId: CORE,
        receiverName: CORE_NAME,
        timeFlag: new Date().getTime(),
        sessionId: 1,
        messageId: 11,
        protoBytesType: "",
        protoBytes: []
      };

      // 发送消息
      Protocol.sender(platform, bgm_core_1_11);

      // console.log('bgm--请求当前tab数据')

      // 请求背景音
      let bgm_scene_6_15 = {
        packageId: 0,
        senderId: BGMUSIC,
        senderName: BGMUSIC_NAME,
        receiverId: SCENE,
        receiverName: SCENE_NAME,
        timeFlag: new Date().getTime(),
        sessionId: 6,
        messageId: 15,
        protoBytesType: "",
        protoBytes: []
      };

      // 发送消息
      Protocol.sender(platform, bgm_scene_6_15);

      // console.log('bgm---请求背景音')

      // 检查场景是否加载完成
      let bgm_scene_6_26 = {
        packageId: 0,
        senderId: BGMUSIC,
        senderName: BGMUSIC_NAME,
        receiverId: SCENE,
        receiverName: SCENE_NAME,
        timeFlag: new Date().getTime(),
        sessionId: 6,
        messageId: 26,
        protoBytesType: "",
        protoBytes: []
      };
      // 发送消息
      Protocol.sender(platform, bgm_scene_6_26);
    };
    window[BGMUSIC_NAME].message = function(
      senderId,
      packageId,
      sessionId,
      messageId,
      protoBytes
    ) {
      // 同步团队型信息
      if (sessionId == 1 && messageId == 12) {
        let is_team = Protocol.deserializeBinary(
          "proto.com.proto.s.MTabData",
          protoBytes
        ).array;

        if (is_team.length > 0 && is_team[5] && is_team[4]) {
          _this.nav = [
            {
              name: "公共市场",
              active: true
            },
            {
              name: "我的",
              active: false
            },
            {
              name: is_team[5],
              active: false
            }
          ];

          _this.team_id = is_team[4];
        } else {
          _this.nav = [
            {
              name: "公共市场",
              active: true
            },
            {
              name: "我的",
              active: false
            }
          ];
        }
    }else if (sessionId == 6 && messageId == 5) { // 场景加载完成
        let token = Protocol.deserializeBinary(
          "proto.com.proto.s.MToken",
          protoBytes
        ).array.toString();

        _this.init = "complete";

        console.log("[" + BGMUSIC_NAME + "][COMPLETE]");

        _this.mask_visible = false;

        let bgm_scene_6_15 = {
          packageId: 0,
          senderId: BGMUSIC,
          senderName: BGMUSIC_NAME,
          receiverId: SCENE,
          receiverName: SCENE_NAME,
          timeFlag: new Date().getTime(),
          sessionId: 6,
          messageId: 15,
          protoBytesType: "",
          protoBytes: []
        };
        // 发送消息
        Protocol.sender(platform, bgm_scene_6_15);

        // console.log('bgm---请求背景音')
    }else if (sessionId == 6 && messageId == 16) { // 同步背景音信息
        let is_team = Protocol.deserializeBinary(
          "proto.com.proto.scene.MAudio",
          protoBytes
        ).array;

        console.log('bgm----->ids======>' + is_team[0])

        if (is_team[0]) {
          _this.handleSyncBgmDetail(_this, is_team[0]);

          _this.bgmId = is_team[0];

          _this.volume = is_team[1].toFixed(2) * 100;

          _this.voice = _this.volume;

          _this.music_play_status = true;
        } else {
          //隐藏播放器
          _this.music_play_status = false;

          let audio = document.getElementById("audio-bgm");

          audio.src = "";

          _this.bgm_title = "";
        }
    }else if (sessionId == 1 && messageId == 4) {  // 同步用户信息--id
        let arr = Protocol.deserializeBinary(
          "proto.com.proto.s.UserInfo",
          protoBytes
        ).array;

        _this.has_user_id = arr[3][0];
    }else if (sessionId == 1 && messageId == 2) { // 同步token
        let is_token = Protocol.deserializeBinary(
          "proto.com.proto.s.MToken",
          protoBytes
        ).array;

        _this.has_token = is_token[0];

        // 初始化背景音-->公共市场-->分类
        _this.handleGetCategory();

        // 初始化背景音-->公共市场-->列表
        _this.handleGetPublicBgmListDate(
          _this.page_size,
          _this.current_page,
          _this.category_id,
          _this.search_key
        );
    }else if (sessionId == 1 && messageId == 12) { // changeTab
        _this.mask_visible = true
    }else if (sessionId == 1 && messageId == 13) { // 锁定模块
        _this.mask_visible = true;
    }else if (sessionId == 1 && messageId == 14) { // 解除锁定
        _this.mask_visible = false;
    }else if(sessionId == 6 && messageId == 29) { //动画播放
        _this.handleBgmPause();
    }else if(sessionId = 6 && messageId == 47) {
        _this.handleBgmPause();
    }else if(sessionId = 2 && messageId == 14) { //时间轴切换模式
        let arr = Protocol.deserializeBinary(
          "proto.com.proto.s.MString",
          protoBytes
        ).array;
        console.log('mTimelineEditMode======>' + arr[0]);
        _this.mTimelineEditMode = arr[0];
    }
    };
  }
};
</script>

<style lang="stylus" scoped>
.audio {
  background: #505050//#e8e8e8;
  position: absolute;
  top: 30px;
  right: 0;
  bottom: 0;
  left: 0;

  .mask {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 280px;
    background: rgba(255, 255, 255, 0.8);
    z-index: 1;
  }

  .tabs {
    display: flex;

    div {
      background: #f0f0f0;
      color: #333;
      flex: 1;
      line-height: 25px;
      border: 1px solid #e9e9e9;
      text-align: center;
      cursor: pointer;
      box-sizing: border-box;
    }

    .active {
      color: #2f2f2f;
      background:#e8e8e8;
    }
  }

  .category-nav {
    padding: 10px;
    height: 20px;

    div {
      float: left;
      height: 20px;
      line-height: 20px;
      background: #dbdbdb;
      font-size: 12px;
      padding: 0 5px;
      margin-right: 10px;
      border-radius: 3px;
      cursor: pointer;
    }

    .active {
      color: #fff;
      background: #7ab3f6;
      font-weight: bold;
    }
  }

  .search {
    padding: 0 10px 10px 10px;
    position: relative;

    .search-inner {
      .text {
        border: 1px solid #e7e7e7;
        background: #fff;
        height: 25px;
        width: 100%;
        padding: 0 5px;
        box-sizing: border-box;
      }

      .button {
        position: absolute;
        top: 0px;
      }

      .icon-search {
        right: 10px;
        color: #E1E1E1;
        font-size: 24px;
        cursor: pointer;

        &:hover {
          color: #717171;
        }

        &:active {
          color: #4A4A4A;
        }
      }

      .el-icon-close {
        right: 40px;
        top: 7px;
        cursor: pointer;
        color: #E1E1E1;

        &:hover {
          color: #717171;
        }

        &:active {
          color: #4A4A4A;
        }
      }
    }
  }

  .player {
    width: 100%;
    height: 30px;

    .box-music {
      background: #c9c9c9;
      margin: 0 10px;
      box-sizing: border-box;
      border-radius: 5px;

      .title {
        padding: 0 10px;
        box-sizing: border-box;
        padding-top: 10px;
        position: relative;
        padding-right: 25px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        .el-icon-close {
          position: absolute;
          cursor: pointer;
          right: 10px;
          color: #aeaeae;
          font-size: 13px;

          &:hover {
            color: #717171;
          }

          &:active {
            color: #4a4a4a;
          }
        }
      }

      .control {
        padding: 0 45px;
        padding-left: 60px;
        box-sizing: border-box;
        position: relative;

        .play_pause {
          position: absolute;
          left: 10px;
          top: 7px;
          overflow: hidden;

          i {
            color: #aeaeae;
            font-size: 20px;
            float: left;
            height: 20px;
            line-height: 20px;

            &:hover {
              color: #717171;
            }

            &:active {
              color: #4a4a4a;
            }
          }

          .icon-volume-mute2 {
            margin-left: 5px;
          }

          .icon-volume-medium {
            margin-left: 5px;
          }

          .icon-play2 {
            cursor: pointer;
          }

          .icon-pause {
            cursor: pointer;
          }
        }

        .volume_show {
          position: absolute;
          right: 10px;
          top: 10px;
          font-size: 14px;
        }
      }
    }

    audio {
      width: 100%;
      height: 30px;
      display: none;
    }
  }

  .content {
    position: absolute;
    top: 80px;
    right: 0;
    bottom: 0;
    left: 0;

    .category-type {
      position: absolute;
      background:#3d3d3d// #dbdbdb;
      color: #e2e2e2//#3d3d3d;
      width: 40px;
      top: 0;
      left: 0;
      bottom: 0;

      div {
        line-height: 30px;
        text-align: center;
        cursor: pointer;
      }

      .active {
        background: #505050//#e8e8e8;
      }
    }

    .list {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 40px;
      box-sizing: border-box;
      padding: 0 5px 5px 5px;
      overflow: auto;

      .breadcrumb {
        line-height: 15px;
        margin-bottom: 10px;
        height: 15px;

        span {
          line-height: 30px;
          display: inline-block;
          padding-right: 5px;
          color: #20a0ff;
          cursor: pointer;
        }
      }

      &.position {
        left: 0;
      }

      .con {
        overflow: hidden;

        .item {
          float: left;
          cursor: pointer;
          position: relative;
          padding: 10px 0;
          border-bottom: 1px solid #c7c7c7;
          width: 100%;

          .inner {
            overflow: hidden;
            padding-left: 45px;

            .padding {
              padding: 10px;
            }

            .pic {
              min-height: 40px;
              width: 40px;
              height: 40px;
              border-radius: 5px;
              float: left;
              position: absolute;
              top: 10px;
              left: 5px;

              img {
                width: 40px;
                height: 40px;
                border-radius: 5px;
                display: block;
              }
            }

            .text {
              float: left;
              margin-left: 10px;
              width: 100%;

              .name, .desc {
                color: #999;
                font-size: 12px;
                height: 15px;
                line-height: 15px;
                box-sizing: border-box;
                margin-top: 5px;
                width: 100%;
              }

              .name {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                color: #e2e2e2//#666;

                .tips {
                  float: right;
                  margin-right: 20px;
                  color: #5e9be3;
                }
              }
            }
          }
        }
      }

      .more {
        padding: 0 5px 5px 5px;

        .inner {
          padding: 10px;
          text-align: center;
          background: #fff;
          cursor: pointer;
        }
      }
    }

    .position-left0 {
      left: 0;
    }
  }

  .position_top {
    top: 150px;
  }

  .no_results {
    width: 200px;
    position: absolute;
    left: 30px;
    top: 150px;

    .pic {
      width: 200px;
      margin: 0 auto;

      img {
        width: 100%;
      }
    }

    .text {
      text-align: center;
      margin-top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Bgm.vue?33ce953c